module.exports = __webpack_public_path__ + "img/LECLERCQ_120X35.67110e79.png";